<template>
  <div id="print-scheme">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto" v-if="true">
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              {{ $t("onsiteUtilities.cardDesigner.createCardDesign") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("onsiteUtilities.cardDesigner.cardDesigns") }}</h5>
              <span v-if="$store.state.printschemes.items.length > 0" v-html="$t('totalContent', [$store.state.printschemes.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/how-to-use-badge-designer-for-your-onsite-events')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="false">
            <upgrade-overlay height="200px"></upgrade-overlay>
          </div>
          <div class="card-body" v-else-if="$store.state.printschemes.items.length > 0">
            <div class="custom-grid-table-header printscheme-grid-template">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <span>{{ $t("onsiteUtilities.cardDesigner.card") }}</span>
              <span>{{ $t("onsiteUtilities.cardDesigner.view") }}</span>
              <span></span>
            </div>
            <draggable :list="$store.state.printschemes.items" tag="div" handle=".el-icon-s-grid" class="list-group-o print-schemes-container" v-bind="dragOptions" @start="dragList = true" @end="changePrintSort">
              <div class="item" v-for="item in $store.state.printschemes.items" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="table-icon">
                  <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                </div>
                <div class="print-title">{{ item.title }}</div>
                <div><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="toggleItem(item.id)"></el-switch></div>
                <div class="action-btns">
                  <el-tooltip effect="dark" :content="$t('event.buttons.copy')" placement="top-end">
                    <el-button circle size="mini" type="warning" icon="fas fa-clone" :loading="loading == 'copy-' + item.id" @click="copyPrintScheme(item.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        updateForm = item.id;
                        modalVisible = true;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'deleteItem-' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-card-design-lottie'"
              :title="$t('onsiteUtilities.cardDesigner.cardDesigns')"
              @btnAdd="
                updateForm = null;
                modalVisible = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateForm != null ? $t('onsiteUtilities.cardDesigner.editCardDesign') : $t('onsiteUtilities.cardDesigner.createCardDesign')" class="large" center modal-append-to-body destroy-on-close>
      <PrintSchemeAddUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" v-if="modalVisible" :id="updateForm" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import PrintSchemeAddUpdate from "../../components/PrintSchemeAddUpdate";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.cardDesign")
    };
  },
  components: { PrintSchemeAddUpdate, PageCountInfo, draggable },
  name: "PrintScheme",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "tags",
      dragList: false,
      loading: false,
      printShort: null
    };
  },
  methods: {
    async changePrintSort() {
      if (this.PrintShort != null) clearTimeout(this.PrintShort);
      this.loading = "loadingList";
      this.PrintShort = setTimeout(async () => {
        var payload = [];
        this.$store.state.printschemes.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("savePrintOrder", payload);
        await this.$store.dispatch("getPrintSchemes");
        this.loading = false;
      }, 500);
      this.dragList = false;
    },
    itemUpdated(item) {
      var index = this.$store.state.printschemes.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.printschemes.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getPrintSchemes");
    },
    handleSizeChange(take) {
      this.$store.commit("setVenueTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setVenuePage", page);
    },
    copyPrintScheme(id) {
      this.loading = "copy-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("copyPrintScheme", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getPrintSchemes");
        }
        this.loading = false;
      }, 500);
    },
    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deletePrintScheme", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getPrintSchemes");
        }
        this.loading = false;
      }, 500);
    },
    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("togglePrintSchemes", id);
      this.loading = false;
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getPrintSchemes");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleVenue", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedVenues", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  async mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getPrintSchemes");
      this.loading = false;
    }, 500);
  },
  created() {},
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.printschemes.filter.page - 1) * this.$store.state.printschemes.filter.take;
    },
    take() {
      return this.skip + this.$store.state.printschemes.items.length;
    }
  },
  watch: {
    "$store.state.printschemes.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getPrintSchemes");
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.printscheme-grid-template {
  grid-template-columns: 30px 1fr 90px 120px;
}
.print-schemes-container {
  display: flex;
  flex-direction: column;
  .item {
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;

    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }

    &.passive {
      background-color: #fff2f2 !important;
    }
    display: grid;
    grid-template-columns: 30px 1fr 90px 120px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    gap: 0.5rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }
    .print-title {
      font-weight: bold;
    }
    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.loading-list {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  i {
    font-size: 20px;
    color: blueviolet;
    font-weight: bold;
  }
}
.collapse-btn-quest-icon {
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.5s;
  &.active {
    transform: rotate(-180deg);
  }
}
.action-btns {
  display: flex;
  gap: 4px;
  & > .el-button {
    margin-left: 0px;
    margin-right: 0px !important;
  }
}
</style>
<style lang="less">
.modal-base-small {
  min-width: 600px !important;
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/PrintScheme.vue